//**auto-generated don't edit this code**//
export enum TestType {
	None,
	YN,
	Score,
	Rubric,
}